import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  translationConstants,
  Directions,
  viewPathConstants,
} from "../../../../../constants";
import get_directions from "../../../../../assets/images/icon/get_directions.svg";
import { googleLocationUrl } from "../../../../../system";
import { authActions, competitionActions } from "../../../../../redux/actions";
import { useLocation, useNavigate } from "react-router-dom";
import { CommaSplitToTranslatedCommaJoined } from "../../../../../system";
import { Col, Row } from "react-bootstrap";

const GeneralTab = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const competitionId = location.state.id;
  const screen = location.state.screen;
  const navigate = useNavigate();

  const [city, setCity] = useState();

  const cities = useSelector((state) => state.LoginReducer.cities);
  const generalData = useSelector(
    (state) => state.CompetitionReducer.competitionGeneralDetail
  );
  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });

  useEffect(() => {
    const findCity = cities?.find((c) => c.id === generalData?.cityId);
    setCity(findCity);
  }, [cities, generalData]);

  useEffect(() => {
    dispatch(authActions.fetchCities(process.env.REACT_APP_Country_Id));
    if (competitionId) {
      dispatch(
        competitionActions.getCompetitionGeneralDetailById(
          competitionId,
          screen
        )
      );
    }
  }, []);

  return (
    <>
      <div className="text-dark mt-5 d-flex flex-column gap-4">
        <div className="col-12 col-md-8 row mt-4">
          <div className="d-flex flex-column flex-lg-row gap-3 gap-lg-5">
            <div className="pb-3">
              <h5 className="fw-bolder">{t(translationConstants.LOCATION)}:</h5>
              <a
                href={
                  generalData?.spotInfo
                    ? undefined
                    : `https://maps.google.com/?q=${generalData?.lat},${generalData?.long}`
                }
                onClick={(e) => {
                  if (generalData?.spotInfo) {
                    e.preventDefault(); // Prevent default link behavior
                    navigate(viewPathConstants.VIEW_SPOT_DETAIL, {
                      state: {
                        centerId: generalData?.spotInfo?.id,
                      },
                    });
                  }
                }}
                target="_blank"
                className="font-16 center-card-view-detail-link d-flex gap-1 align-items-center"
              >
                <img src={get_directions} alt="get directions icon" />
                {direction === Directions.rtl
                  ? generalData?.spotInfo?.arabicSpotName ||
                    generalData?.spotInfo?.spotName
                  : generalData?.spotInfo?.spotName}
                {direction === Directions.rtl
                  ? city?.arabicName || city?.name
                  : city?.name}
              </a>
            </div>
            <div className="pb-3">
              <div>
                <h5 className="font-18 fw-bolder">
                  {t(translationConstants.AGE_LIMIT)}:
                </h5>
              </div>
              <div>
                <p className="font-16">{` ${generalData?.minAge} - ${
                  generalData?.maxAge
                } ${t(translationConstants.YEARS)}`}</p>
              </div>
            </div>
            {generalData?.registrationFee && (
              <div className="pb-3">
                <div>
                  <h5 className="font-18 fw-bolder">
                    {t(translationConstants.REGISTRATION_FEES)}:
                  </h5>
                </div>
                <div>
                  <p className="font-16">{`${translationConstants.SAR} ${generalData?.registrationFee}`}</p>
                </div>
              </div>
            )}
            <div className="pb-3">
              <div>
                <h5 className="font-18 fw-bolder">
                  {t(translationConstants.important_documents)}:
                </h5>
              </div>
              <div>
                <a
                  href={generalData?.nor?.link}
                  target="_blank"
                  className="font-16 underline"
                >
                  {t(translationConstants.NOTICE_OF_RACE)}
                </a>
              </div>
            </div>
          </div>
        </div>
        {generalData?.providedServices && (
          <div className="col-4 col-md-4 mb-3">
            <h5 className="fw-bolder">{t(translationConstants.SERVICES)}:</h5>
            <span className="general-tab-span font-16">
              {CommaSplitToTranslatedCommaJoined(
                generalData?.providedServices,
                t
              )}
            </span>
          </div>
        )}
        {generalData?.description ? (
          <div className="row text-dark">
            <div className="col-12 col-md-7">
              <h5 className="fw-bolder">
                {t(translationConstants.DESCRIPTION)}
              </h5>
              <span className="general-tab-span w-75 font-14 text-break">
                {direction === Directions.rtl
                  ? generalData.arabicDescription || generalData.description
                  : generalData.description}
              </span>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default GeneralTab;
